import type { AppDispatch } from '@/app/store';
import { resetAnalysisApiState } from './analysisApi';
import { resetStatisticsApiState } from './statisticsSlice';
import { resetFieldApiState } from './fieldSlice';
import { resetProgramApiState } from './programSlice';
import { resetListApiState } from './customListSlice';
import { resetNetworkGroupSlice } from './networkGroupSlice';
import { resetWorklogApiState } from './worklogSlice';
import { resetScanApiState } from './scanSlice';
import { resetDatasetApiState } from './datasetSlice';
import { resetWildfireApiState } from './wildfireSlice';
import { resetContractorsApiState } from './contractorSlice';
import { resetReliabilityConfigApiState } from './reliabilityConfigSlice';
import { resetAdminApiState } from './adminSlice';
import { resetProjectApiState } from './projectSlice';
import { resetBosunApiState } from './bosunApi';

/**
 * Clears every RTK Query cache that holds client-scoped data. The active client
 * rides only in the `X-Overstory-Email` header, never in a cache key, so two
 * clients hitting the same endpoint with the same args collide on one cache
 * entry. Resetting these caches forces a refetch under the new client's header.
 *
 * `mapboxApi` is intentionally excluded — it targets Mapbox, not our API, and
 * carries no client identity.
 */
export const resetClientScopedApiState = (dispatch: AppDispatch): void => {
  dispatch(resetAnalysisApiState());
  dispatch(resetStatisticsApiState());
  dispatch(resetFieldApiState());
  dispatch(resetProgramApiState());
  dispatch(resetListApiState());
  dispatch(resetNetworkGroupSlice());
  dispatch(resetWorklogApiState());
  dispatch(resetScanApiState());
  dispatch(resetDatasetApiState());
  dispatch(resetWildfireApiState());
  dispatch(resetContractorsApiState());
  dispatch(resetReliabilityConfigApiState());
  dispatch(resetAdminApiState());
  dispatch(resetProjectApiState());
  dispatch(resetBosunApiState());
};
